import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close--sprite",
  "use": "close--sprite-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol viewBox=\"0 0 52 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close--sprite\">\n<path d=\"M14 14L38 38\" stroke-width=\"4\" />\n<path d=\"M38 14L14 38\" stroke-width=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol